import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstLetter',
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
  public transform(label: string): string {
    if (!label || label.length < 2) {
      return label || '';
    }
    return label[0].toUpperCase() + label.slice(1);
  }
}
